export function initStarRatingComponent(form:HTMLFormElement) {
    const starContainer = document.querySelector('.star-rating-container') as HTMLElement;
    if (!starContainer) return; // Ensure starContainer exists

    const stars = Array.from(starContainer.children) as HTMLSpanElement[];
    const inputRating = starContainer.querySelector('input[name="review_rating"]') as HTMLInputElement;
    const ratingText = document.getElementById('rating-text');

    let selectedRating = parseInt(inputRating.value) || 0;

    // Function to update the visual state of the stars
    function updateStarDisplay(currentRating:number) {
        const selectedValue = parseInt(inputRating.value) || 0;
        stars.forEach(star => {
            const starValue = parseInt(star.dataset.value || '0');
            if (starValue <= currentRating) {
                star.classList.add('highlighted');
            } else {
                star.classList.remove('highlighted');
            }
            if (starValue <= selectedValue)  {
                star.classList.add('selected');
            } else {
                star.classList.remove('selected');
            }
        });
    }

    // --- Mouse Events ---
    starContainer.addEventListener('mouseover', (event) => {
        const target = event.target as Element | null;
        const hoveredStar = target && target.closest ? target.closest('.star') as HTMLElement : null;
        if (hoveredStar) {
            const hoverValue = parseInt((hoveredStar as HTMLElement).dataset.value || '0');
            updateStarDisplay(hoverValue);
        }
    });

    starContainer.addEventListener('mouseout', () => {
        // When mouse leaves, revert to selected rating or no highlight
        updateStarDisplay(selectedRating);
    });

    starContainer.addEventListener('click', (event) => {
        const target = event.target as Element | null;
        const clickedStar = target && target.closest ? target.closest('.star') as HTMLElement : null;
        if (clickedStar) {
            selectedRating = parseInt(clickedStar.dataset.value || '0');
            inputRating.value = selectedRating.toString();
            updateStarDisplay(selectedRating);
        }
    });

    // --- Touch Events (for mobile responsiveness) ---
    let touchMoved = false;

    starContainer.addEventListener('touchstart', (event) => {
        event.preventDefault(); // Prevent default browser touch behavior (e.g., scrolling)
        touchMoved = false;
        const touch = event.touches[0];
        if (!touch) return; // Ensure touch is defined

        const star = getTouchedStar(touch.clientX, touch.clientY) as any;
        if (star) {
            const touchValue = parseInt(star.dataset.value);
            updateStarDisplay(touchValue);
        }
    }, { passive: false }); // Use passive: false to allow preventDefault

    starContainer.addEventListener('touchmove', (event) => {
        event.preventDefault(); // Prevent scrolling while dragging finger over stars
        touchMoved = true;
        const touch = event.touches[0] as any;
        const star = getTouchedStar(touch.clientX, touch.clientY) as any;
        if (star) {
            const touchValue = parseInt(star.dataset.value);
            updateStarDisplay(touchValue);
        }
    }, { passive: false });

    starContainer.addEventListener('touchend', (event) => {
        event.preventDefault(); // Prevent default touch behavior
        const touch = event.changedTouches[0] as any; // Use changedTouches for touchend
        const star = getTouchedStar(touch.clientX, touch.clientY) as any;
        if (star && !touchMoved) { // Only 'click' if no significant movement occurred
            selectedRating = parseInt(star.dataset.value) ;
            updateStarDisplay(selectedRating);
        } else if (touchMoved) {
            // If touch moved, revert to selected rating or none
            updateStarDisplay(selectedRating);
        }
    }, { passive: false });

    // Helper function to get the star element at a given touch coordinate
    function getTouchedStar(x:number, y:number) {
        const elements = document.elementsFromPoint(x, y);
        return elements.find(el => el.classList.contains('star'));
    }

    // handle form reset
    form.addEventListener('reset', () => {
        selectedRating = 0;
        inputRating.value = selectedRating.toString();
        updateStarDisplay(selectedRating);
    });

    // Initial display (in case selectedRating starts non-zero)
    updateStarDisplay(selectedRating);

}